import { Box, Heading, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface Props {
  titulo: string;
  descricao?: string;
}

/** Bloco branco com título, usado para separar as seções do formulário. */
const Secao: FC<Props> = ({ titulo, descricao, children }) => (
  <Box
    as="section"
    bg="white"
    border="1px solid #D6E8FF"
    borderRadius="12px"
    p={6}
    w="100%"
  >
    <Heading as="h2" size="md" color="#469BFF" fontFamily="Poppins" mb={1}>
      {titulo}
    </Heading>
    {!!descricao && (
      <Text color="gray.600" fontSize="sm" mb={4}>
        {descricao}
      </Text>
    )}
    <Box mt={descricao ? 0 : 4}>{children}</Box>
  </Box>
);

export default Secao;
